export const Spacer = ({ vertical, horizontal }) => (
  <div style={{ height: vertical, width: horizontal }} />
);
